import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20manga%20and%20comic%20illustration%20background%20with%20warm%20red%20and%20cream%20tones%2C%20Japanese%20ink%20wash%20painting%20style%20blended%20with%20modern%20geometric%20elements%2C%20soft%20gradient%2C%20elegant%20minimalist%20composition%2C%20cultural%20aesthetic%2C%20no%20text%2C%20atmospheric%20lighting&width=1800&height=700&seq=hero-bg-2026&orientation=landscape"
        alt="JM Comic 背景"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-5 leading-tight">
          JM Comic — 官方入口与完整使用指南
        </h1>
        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          JM Comic 是广受欢迎的漫画阅读平台，提供海量正版与同人漫画资源。
          本站为您详解访问方式、注册流程、分类导航、会员权益及常见问题，助您快速上手，畅享优质漫画内容。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/article/jm-comic-register-guide"
            className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-medium whitespace-nowrap hover:bg-primary-600 transition-all cursor-pointer"
          >
            查看注册教程
          </Link>
          <Link
            to="/categories"
            className="px-8 py-3.5 bg-background-50/10 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-base font-medium whitespace-nowrap hover:bg-background-50/20 transition-all cursor-pointer"
          >
            浏览分类导航
          </Link>
        </div>
      </div>
    </section>
  );
}